function SelectionSummary({ title, items }) {
  if (!items?.length) return null;

  return (
    <div className="selection-summary" role="region" aria-label={title}>
      {title && <p className="selection-summary-heading">{title}</p>}
      <dl className="selection-summary-list">
        {items.map(({ label, value }) => (
          <div key={label} className="selection-summary-row">
            <dt>{label}</dt>
            <dd>{value || '-'}</dd>
          </div>
        ))}
      </dl>
    </div>
  );
}

export default SelectionSummary;
